import WikiPageView from "./WikiPageView";

import "./WikiPageView.scss";

export * from "./WikiPageView.types";

export { WikiPageView };